import ComicCard from "@/components/base/ComicCard";
import { allComics } from "@/mocks/comics";
import { useState } from "react";

const tabs = ["最新更新", "人气最高", "评分最高"];

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState(0);
  const [page, setPage] = useState(1);
  const perPage = 6;
  const totalPages = Math.ceil(allComics.length / perPage);

  const getSorted = () => {
    const sorted = [...allComics];
    if (activeTab === 0) sorted.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
    if (activeTab === 1) sorted.sort((a, b) => b.views - a.views);
    if (activeTab === 2) sorted.sort((a, b) => b.rating - a.rating);
    return sorted;
  };

  const comics = getSorted().slice((page - 1) * perPage, page * perPage);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              漫画大全
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              海量韩国漫画资源，随心畅读
            </p>
          </div>
          <div className="flex items-center bg-background-200/60 rounded-full p-1">
            {tabs.map((tab, idx) => (
              <button
                key={tab}
                onClick={() => {
                  setActiveTab(idx);
                  setPage(1);
                }}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  idx === activeTab
                    ? "bg-background-50 text-foreground-900"
                    : "text-foreground-500 hover:text-foreground-700"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {comics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="small" />
          ))}
        </div>

        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-1.5 mt-8">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
              <button
                key={p}
                onClick={() => setPage(p)}
                className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  p === page
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {p}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}